import { DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { openSnackbar } from '../../redux/slices/common';
import { closeCustomModalDialog } from '../../redux/slices/modalSlice';
import { createProductTagAPI } from '../../redux/apis/products';

export default function AddNewTagModal({ closeModal }) {
  const { modalData } = useSelector(state => state.modal);
  const { fetchTagListing = () => {} } = modalData;
  const dispatch = useDispatch();
  const [tagName, setTagName] = useState('');

  const showError = (message, errorType) => {
    if (errorType === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errorType === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const handleSave = () => {
    const trimmed = tagName.trim();
    if (!trimmed) return;
    createProductTagAPI({ tags: trimmed })
      .then(res => {
        showError(res?.data?.message || 'Tag created successfully', 'success');
        dispatch(closeCustomModalDialog());
        fetchTagListing();
      })
      .catch(err => {
        showError(err?.response?.data?.message || err?.message || 'Failed to create tag', 'error');
      });
  };

  return (
    <>
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
        Add New Tag
        <IconButton onClick={closeModal} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <TextField
            fullWidth
            label="Tag Name"
            value={tagName}
            onChange={e => setTagName(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
            sx={{ mt: 1 }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions className='footer-modal' style={{ marginBottom: '12px' }}>
        <MDButton
          onClick={closeModal}
          sx={{ minWidth: '160px' }}
          type='button'
          variant='outlined'
          color='dark'
        >
          Cancel
        </MDButton>
        <MDButton
          onClick={handleSave}
          disabled={!tagName.trim()}
          sx={{ minWidth: '160px' }}
          color='primary'
          type='button'
          variant='contained'
        >
          Save
        </MDButton>
      </DialogActions>
    </>
  );
}
